import React from 'react';
import { ui } from '../../styles/shared';

// Stilar från den gemensamma stilfilen
const card = ui.card;
const btn = ui.btn;

interface Props {
    brightness: number;
    onBrightnessChange: (v: number) => void;
    onApply: (brightness: number) => void;
    readOnly?: boolean;
}

const DimmerControl: React.FC<Props> = ({ brightness, onBrightnessChange, onApply, readOnly }) => (
    <div style={card}>
        <h3 style={{ marginTop: 0 }}>🎚️ Styr dimmer</h3>
        <div style={{ marginBottom: '20px' }}>
            <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>
                Nivå: {brightness} / 255 ({Math.round((brightness / 255) * 100)} %)
            </label>
            {!readOnly && (
                <>
                    <input type="range" min="0" max="255" value={brightness}
                        onChange={e => onBrightnessChange(Number(e.target.value))}
                        style={{ width: '100%', height: '8px' }} />
                    <button onClick={() => onApply(brightness)}
                        style={{ ...btn('#007bff'), marginTop: '10px', padding: '8px 16px' }}>Spara nivå</button>
                </>
            )}
        </div>
    </div>
);

export default DimmerControl;
